import React from 'react';

const PublicCategoriesTab = ({ filteredPublicCats, loading, toggleShowcase, copyCategory, copyCategoryWithUrls, showcaseCatId, showcaseUrls, showcaseLoading }) => (
  <div data-testid="public-categories-tab">
    {loading && <div style={{ color: '#71717a', textAlign: 'center', padding: 40 }}>Loading public categories...</div>}
    {!loading && filteredPublicCats.length === 0 && (
      <div style={{ color: '#71717a', textAlign: 'center', padding: 40 }}>No public categories found.</div>
    )}
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: 12 }}>
      {filteredPublicCats.map(cat => (
        <div key={cat.id} className="ocean-shimmer shimmer-border" style={{
          background: '#475569', borderRadius: 12, padding: 16, position: 'relative',
          border: '1px solid rgba(253, 230, 138,0.15)', overflow: 'hidden'
        }} data-testid={`public-cat-${cat.id}`}>
          <div style={{ position: 'relative', zIndex: 4 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
              <div>
                <h4 style={{ margin: 0, color: '#334155', fontSize: '0.95rem', fontWeight: 700 }}>
                  {cat.level > 0 && <span style={{ color: '#71717a', marginRight: 4 }}>{'  '.repeat(cat.level)}{'└─ '}</span>}
                  {cat.name}
                </h4>
                <span style={{ color: '#71717a', fontSize: '0.68rem' }}>by {cat.creator_name}</span>
              </div>
              <span style={{ background: 'rgba(16,185,129,0.15)', color: '#10b981', padding: '2px 8px', borderRadius: 6, fontSize: '0.68rem', fontWeight: 600, whiteSpace: 'nowrap' }}>
                {cat.url_count} URLs
              </span>
            </div>
            {cat.protocol && (
              <div style={{ background: 'rgba(252, 211, 77,0.08)', padding: '4px 8px', borderRadius: 6, marginBottom: 8, fontSize: '0.7rem', color: '#c4b5fd', fontFamily: 'monospace', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {cat.protocol}
              </div>
            )}
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => toggleShowcase(cat.id)} className="btn-ocean" data-testid={`showcase-cat-${cat.id}`}
                style={{ background: showcaseCatId === cat.id ? 'rgba(245,158,11,0.15)' : 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.3)', color: '#f59e0b', padding: '6px 10px', borderRadius: 8, cursor: 'pointer', fontSize: '0.74rem', fontWeight: 600 }}>
                <i className={`fas ${showcaseCatId === cat.id ? 'fa-eye-slash' : 'fa-eye'}`} style={{ marginRight: 4 }} /> {showcaseCatId === cat.id ? 'Close' : 'Preview'}
              </button>
              <button onClick={() => copyCategory(cat)} className="btn-ocean" data-testid={`copy-cat-${cat.id}`}
                style={{ flex: 1, background: 'rgba(252, 211, 77,0.12)', border: '1px solid rgba(252, 211, 77,0.3)', color: '#047857', padding: '6px 10px', borderRadius: 8, cursor: 'pointer', fontSize: '0.74rem', fontWeight: 600 }}>
                <i className="fas fa-copy" style={{ marginRight: 4 }} /> Copy Category
              </button>
              <button onClick={() => copyCategoryWithUrls(cat)} className="btn-ocean" data-testid={`copy-cat-urls-${cat.id}`}
                style={{ flex: 1, background: 'rgba(253, 230, 138,0.12)', border: '1px solid rgba(253, 230, 138,0.3)', color: '#38bdf8', padding: '6px 10px', borderRadius: 8, cursor: 'pointer', fontSize: '0.74rem', fontWeight: 600 }}>
                <i className="fas fa-download" style={{ marginRight: 4 }} /> Copy + URLs
              </button>
            </div>
            {showcaseCatId === cat.id && (
              <div style={{ marginTop: 10, background: 'rgba(245,158,11,0.05)', borderRadius: 8, padding: 12, border: '1px solid rgba(245,158,11,0.15)', maxHeight: 300, overflowY: 'auto' }}
                data-testid={`showcase-panel-${cat.id}`}>
                <h5 style={{ margin: '0 0 8px', color: '#f59e0b', fontSize: '0.82rem' }}>
                  <i className="fas fa-eye" style={{ marginRight: 6 }} />Showcase Preview (Read-Only)
                </h5>
                {showcaseLoading && <div style={{ color: '#71717a', fontSize: '0.75rem', textAlign: 'center', padding: 20 }}>Loading URLs...</div>}
                {!showcaseLoading && showcaseUrls.length === 0 && <div style={{ color: '#71717a', fontSize: '0.75rem' }}>No URLs in this category.</div>}
                {!showcaseLoading && showcaseUrls.map((u, i) => (
                  <div key={i} style={{ padding: '6px 0', borderBottom: '1px solid rgba(255, 255, 255, 0.85)', fontSize: '0.75rem' }}>
                    <a href={u.url} target="_blank" rel="noopener noreferrer" style={{ color: '#38bdf8', textDecoration: 'none', fontWeight: 600 }}>
                      {u.title || u.url}
                    </a>
                    {u.root_domain && <span style={{ color: '#71717a', marginLeft: 6, fontSize: '0.65rem' }}>{u.root_domain}</span>}
                    {u.article_type && <span style={{ color: '#047857', marginLeft: 6, fontSize: '0.6rem', background: 'rgba(252, 211, 77,0.1)', padding: '1px 5px', borderRadius: 4 }}>{u.article_type}</span>}
                    {u.snippet && <p style={{ color: '#a1a1aa', fontSize: '0.68rem', margin: '2px 0 0', lineHeight: 1.4 }}>{u.snippet.substring(0, 120)}...</p>}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default PublicCategoriesTab;
